//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { useDispatch } from 'react-redux';

import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';

interface CampaignSuccessToast {
  message?: string;
  title: string;
}

export const useCampaignSuccessToast = () => {
  const dispatch = useDispatch();

  const showSuccessToast = ({ message, title }: CampaignSuccessToast) => {
    dispatch(
      toastNotificationsActions.addToastNotification({
        message,
        options: { toastTemplate: ALTERNATE_TOASTS.NEW_TOAST },
        title,
        type: ToastType.SUCCESS,
      }),
    );
  };

  return { showSuccessToast };
};
